<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li
      *ngFor="let breadcrumb of breadcrumbs; let last = last"
      [ngClass]="{ active: last }"
    >
      <!-- Hyperlinked breadcrumbs for all but the last -->

      <a
        *ngIf="!last"
        class="notLast-breadcrumb"
        [routerLink]="[
          breadcrumb.url === '/profile' ? '/profile/organizationprofile' : breadcrumb.url,
        ]"
        >{{ breadcrumb.label | translate }}</a
      >

      <!-- Separator logic: only show the separator if it's not the last breadcrumb item -->
      <span *ngIf="!last" class="breadcrumb-separator" style="margin-left: 10px">
        &gt;
      </span>

      <!-- Plain text label for the last breadcrumb item -->
      <span *ngIf="last" class="last-breadcrumb">{{ breadcrumb.label | translate }}</span>
    </li>
  </ol>
</nav>
